<template>
  <div
    class="inner"
    :class="{ swiping: isSwiping }"
    :style="{ transform: `translateY(${translateY}px)` }"
  >
    <SwipeWrapper
      @pan-start="handleSwipeDownStart"
      @pan-move="handleSwipeMove"
      @pan-end="handleSwipeDownEnd"
    >
      <div class="swipe"></div>
    </SwipeWrapper>
    <h2>{{ title }}</h2>
    <p>{{ text }}</p>
    <BookingsForDeleteTable :bookings="props.body.booksForDelete" />

    <div class="buttons">
      <VButton @click="deleteBookings" class="button">
        Удалить бронирования
      </VButton>
      <VButton @click="closeModal" class="button" outline> Отменить </VButton>
    </div>
    <IconPopupCross
      v-if="screenWidth !== 'mobile'"
      class="modal-cross"
      @click="closeModal"
    />
  </div>
</template>

<script setup>
import { computed, defineProps, ref } from "vue";
import { useStore } from "vuex";
import IconPopupCross from "@/components/icons/IconPopupCross.vue";
import VButton from "@/components/ui/VButton.vue";
import SwipeWrapper from "@/components/ui/SwipeWrapper.vue";
import BookingsForDeleteTable from "@/components/pages/catering/BookingsForDeleteTable.vue";
import { API } from "@/assets/js/api/api";
import { useRouter } from "vue-router";

const props = defineProps({
  error: String,
  body: Object,
  type: String,
});

const store = useStore();
const router = useRouter();

const screenWidth = computed(() => {
  return store.getters.screenType;
});

const title = computed(() => {
  if (props.type === "form") {
    return "Ошибка во времени работы";
  } else if (props.type === "scheme") {
    return "Ошибка в изменении карты посадки";
  } else {
    return "";
  }
});

const text = computed(() => {
  if (props.type === "form") {
    return "У заведения есть активные бронирования на время, не входящие в новый диапазон работы. Чтобы поменять режим работы, необходимо в ручную удалить проблемные бронирования.";
  } else if (props.type === "scheme") {
    return "У заведения есть активные бронирования на столы, которые были удалены. Чтобы сохранить новую схему посадки, необходимо в ручную удалить проблемные бронирования.";
  } else {
    return "";
  }
});

const isSwiping = ref(false);
const translateY = ref(0);
const threshold = ref(100);

const closeModal = () => {
  store.dispatch("closeModal");
};

const updateCatering = async (cateringData) => {
  const updateMethod =
    store.getters.roleGroup === "biz"
      ? API.business.catering.updateCateringByBiz
      : API.business.catering.updateCatering;

  await updateMethod(cateringData);
};

const updateScheme = async (cateringData) => {
  const updateMethod =
    store.getters.roleGroup === "biz"
      ? API.scheme.updateSchemeByMajor
      : API.scheme.updateSchemeByEviso;

  await updateMethod(cateringData);
};

const deleteBookings = async () => {
  if (props.type === "form") {
    await updateCatering(props.body);
  }
  if (props.type === "scheme") {
    await updateScheme(props.body);
  }
  await store.dispatch("closeModal");
  await router.push("/account/catering");
};

const handleSwipeDownStart = () => {
  isSwiping.value = true;
};

const handleSwipeDownEnd = () => {
  if (translateY.value > threshold.value) {
    closeModal();
  } else {
    translateY.value = 0;
    isSwiping.value = false;
  }
};

const handleSwipeMove = (event) => {
  if (event.deltaY > 0) {
    translateY.value = event.deltaY;
  }
};
</script>

<style lang="scss" scoped>
.inner {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 640px;
  margin: auto;
  padding: 32px 56px 40px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;

  @media screen and (max-width: 841px) {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    max-width: 100%;
    box-shadow: 0 -2px 10px 0 #0000000d;
    border-radius: 20px 20px 0 0;
    padding: 32px 24px 24px 24px;
  }

  &.swiping {
    transition: none;
  }
}

h2 {
  margin-bottom: 24px;
  text-align: center;
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  color: #f0811e;
}

p {
  width: 100%;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: #222222;
  margin-bottom: 32px;
}

.buttons {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 360px;
  gap: 16px;
  margin: 32px auto 0;

  @include mobile {
    margin: 32px auto 0;
    width: 100%;
  }
}

.modal-cross {
  position: absolute;
  top: 25px;
  right: 25px;
  cursor: pointer;
}

.swipe {
  display: none;

  @include mobile {
    display: block;
    position: absolute;
    width: 100%;
    height: 20px;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 16px 16px 0 0;
    background-color: #ffffff;

    &::before {
      content: "";
      left: 50%;
      position: absolute;
      top: 6px;
      transform: translate(-50%);
      width: 36px;
      height: 6px;
      border-radius: 4px;
      background-color: #d6d6d6;
    }
  }
}
</style>
